import { POSTHOG_INGEST_PATH } from '@remote-medium/shared';
import { initAnalytics } from '@remote-medium/ui/lib/analytics';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

import '@remote-medium/ui/globals.css';

import { SITE_ORIGIN } from '../lib/config.ts';
import { router } from './router.tsx';

// Analytics is a no-op without VITE_POSTHOG_KEY.
initAnalytics({
  key: import.meta.env['VITE_POSTHOG_KEY'] as string | undefined,
  app: 'admin',
  apiHost: `${SITE_ORIGIN}${POSTHOG_INGEST_PATH}`,
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
